// This is generated.  Alter it in blockGroups/formElements/types/ShortText.js
/* eslint-disable no-unused-vars */
const { Type } = require('@sinclair/typebox');
const { moduleRegistration } = require('@sstdev/lib_metadata-config');
module.exports = {
  asDataDictionary: function asDataDictionary(hNode, context) {
    const {
      id,
      title,
      propertyName,
      minLength,
      maxLength,
      pattern,
      required,
      defaultValue,
    } = hNode;
    //This block tells us nothing about namespaces/relations
    const subDataDictionary = {};
    // reuse consistent flags
    const { isRequired, isEditable, isOptional, forAction } =
      moduleRegistration.resolveFieldFlags(required, context);
    const maybeOptional = (schema) =>
      isOptional ? Type.Optional(schema) : schema;

    // Build the string schema with constraints
    const stringOptions = {
      title: title,
      'x-id': id,
      'x-dataType': 'string',
      'x-propertyName': propertyName,
      'x-required': isRequired,
      'x-optional': isOptional,
      'x-editable': isEditable,
    };

    // Add forAction annotation if this field is within a DetailPane with a specific action
    // Downstream merge logic uses this to keep required scoped to the right action
    if (forAction) {
      stringOptions['x-forAction'] = forAction;
    }

    // Add constraints if provided
    if (minLength !== undefined && minLength !== null) {
      stringOptions.minLength = minLength;
    }
    if (maxLength !== undefined && maxLength !== null) {
      stringOptions.maxLength = maxLength;
    }
    if (pattern) {
      stringOptions.pattern = pattern;
    }
    if (defaultValue) {
      stringOptions.default = defaultValue;
    }

    const shortTextSchema = maybeOptional(Type.String(stringOptions));

    // The partial type definition is a plain object with the property schema
    const partialTypeDefinition = {
      [propertyName]: shortTextSchema,
    };

    return [subDataDictionary, partialTypeDefinition];
  },
};
moduleRegistration.registerHNodeType(
  'formElements',
  'ShortText',
  module.exports,
);
